import React, { cloneElement } from 'react';
import { Check, ChevronRight, BookOpen, Droplet, Calculator, Package, Calendar, Smartphone, Coffee, Gift, ShoppingBag, Star, X } from 'lucide-react';
import { FAQ } from './components/FAQ';
export function App() {
  return <div className="min-h-screen bg-[#F7F1E8] font-['Inter',sans-serif] text-[#5A3A28] selection:bg-[#E8B3C1] selection:text-[#5A3A28]" data-id="element-0" data-mp="3k78bh93vless">
      {/* 1. HERO SECTION */}
      <section id="hero" className="relative py-8 px-6 lg:px-12 max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-1" data-mp="2rlf5kqna9k1s">
        <div className="flex-1 z-10 w-full max-w-2xl lg:max-w-none mx-auto" data-id="element-2" data-mp="31ayq00qn9lyr">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#EF9F27] text-white font-semibold text-sm mb-8 shadow-sm" data-id="element-3" data-mp="2wka0gqyiyz29">
            <span data-id="element-4" data-mp="28suu8n3mnxlq">🔥 Precio de lanzamiento — Solo por tiempo limitado</span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 leading-[1.1] text-[#5A3A28]" data-id="element-5" data-mp="23ujmchww7x65">
            EMPRENDÉ CON <span className="text-[#ED93B1]" data-id="element-6" data-mp="3ii4s22026sok">MINICOOKIES</span>{' '}
            DESDE TU CASA
          </h1>

          <p className="text-lg sm:text-xl text-[#5A3A28]/80 mb-8 font-medium leading-relaxed" data-id="element-7" data-mp="3rc9e8848zfxr">
            Aprendé a producir, presentar y vender minicookies irresistibles con
            una app interactiva lista para usar.
          </p>

          <ul className="space-y-4 mb-10" data-id="element-8" data-mp="2zm4wyibsb90r">
            {['Recetas probadas', 'Costos y precios sugeridos', 'Packaging recomendado', 'Plan para conseguir tus primeras ventas'].map((item, i) => <li key={i} className="flex items-center gap-3 text-lg font-medium" data-id="element-9" data-mp="3dkl58dpap7l0" data-mpi={i}>
                <div className="bg-[#C98A4B] rounded-full p-1" data-id="element-10" data-mp="nuhicimzqbua">
                  <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-11" data-mp="sudk0b87tr6o" />
                </div>
                {item}
              </li>)}
          </ul>

          <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-12" data-mp="34ndfy2z19zs">
            <a href="https://minicookieslab.impultienda.ar/" target="_blank" rel="noopener" className="w-full sm:w-auto group relative inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#5A3A28] hover:bg-[#4a2f20] text-white rounded-full font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-0.5" data-id="element-13" data-mp="3ubzrw5cgz9c0">
              QUIERO ACCEDER AHORA
              <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-14" data-mp="3qb7hv9vrx0eo" />
            </a>
            <a href="#que-incluye" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 bg-transparent hover:bg-[#5A3A28]/5 text-[#5A3A28] rounded-full font-bold text-lg transition-all duration-300 border-2 border-[#5A3A28]/20 hover:border-[#5A3A28]" data-id="element-15" data-mp="3lkr57rzs1itd">
              VER TODO LO QUE INCLUYE
            </a>
          </div>

          <p className="mt-5 text-sm font-semibold text-[#5A3A28]" data-id="element-16" data-mp="1d47wfexhkyzn">
            $16.990 · o 3 cuotas de $5.663 sin interés con Mercado Pago 💳
          </p>
          <p className="mt-1 text-sm text-[#5A3A28]/70 font-medium" data-id="element-17" data-mp="yh6agziftk4p">
            🔒 Acceso inmediato · De por vida · Sin suscripción
          </p>
        </div>

        <div className="flex-1 relative w-full max-w-2xl lg:max-w-none mx-auto" data-id="element-18" data-mp="1r3zh1yiiddmm">
          <div className="absolute inset-0 bg-[#E8B3C1]/20 rounded-[2.5rem] transform rotate-3 scale-105 -z-10" data-id="element-19" data-mp="1w33nwihymz9s"></div>
          <img src="https://cdn.magicpatterns.com/uploads/7Qsv58MeAQsJJ5h3eAKBBH/ChatGPT_Image_17_jun_2026,_07_48_28_p.m..png" alt="Minicookies Premium Mockup" className="rounded-[2.5rem] shadow-2xl object-cover w-full h-auto aspect-[4/5] lg:aspect-square" data-id="element-20" data-mp="1i4cevahyg3si" />
        </div>
      </section>

      {/* 2. QUÉ INCLUYE */}
      <section id="que-incluye" className="scroll-mt-8 py-8 px-6 lg:px-12 bg-white" data-id="element-21" data-mp="ano95x7j5zcl">
        <div className="max-w-[1400px] mx-auto" data-id="element-22" data-mp="m6fcwqpq0vif">
          <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-16 text-[#5A3A28]" data-id="element-23" data-mp="m5ni3i3y71t7">
            ¿QUÉ INCLUYE MINICOOKIES LAB?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-24" data-mp="c8j1dxsvfyjs">
            {[{
            icon: <BookOpen data-id="element-25" data-mp="19w9ol4yb0e13" />,
            title: 'Recetas Premium',
            desc: 'Fórmulas exactas para cookies perfectas.'
          }, {
            icon: <Droplet data-id="element-26" data-mp="zxk557qreliq" />,
            title: 'Salsas para Dipping',
            desc: 'Complementos irresistibles para tus ventas.'
          }, {
            icon: <Calculator data-id="element-27" data-mp="vykzfkx7ekq8" />,
            title: 'Costos y Precios',
            desc: 'Calculadora automática de rentabilidad.'
          }, {
            icon: <Package data-id="element-28" data-mp="3gl64ml1oaikv" />,
            title: 'Packaging y Conservación',
            desc: 'Presentaciones que enamoran a tus clientes.'
          }, {
            icon: <Calendar data-id="element-29" data-mp="206js98wzjk3d" />,
            title: 'Planner de Producción',
            desc: 'Organización paso a paso para escalar.'
          }, {
            icon: <Smartphone data-id="element-30" data-mp="29wv89tty1jqm" />,
            title: 'App Interactiva',
            desc: 'Todo tu negocio en la palma de tu mano.'
          }].map((item, i) => <div key={i} className="bg-[#F7F1E8] p-8 rounded-3xl border border-[#5A3A28]/10 hover:border-[#C98A4B] transition-colors duration-300 flex flex-col items-center text-center group" data-id="element-31" data-mp="2jt834v1863my" data-mpi={i}>
                <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center text-[#C98A4B] mb-6 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-32" data-mp="2stwetj35brwo">
                  {cloneElement(item.icon, {
                className: 'w-8 h-8'
              })}
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-33" data-mp="21tf2b6zie4fb">{item.title}</h3>
                <p className="text-[#5A3A28]/70 font-medium" data-id="element-34" data-mp="1wu25btexbgz0">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* COMPARATIVA: NO ES OTRO PDF */}
      <section id="comparativa" className="scroll-mt-8 py-8 px-6 lg:px-12 bg-[#E8B3C1]/10" data-id="element-35" data-mp="25rm856sfplbq">
        <div className="max-w-[1000px] mx-auto text-center" data-id="element-36" data-mp="2kolkf7y8e2cj">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4 text-[#5A3A28]" data-id="element-37" data-mp="2fqae3775a9z2">
            No es otro PDF
          </h2>
          <p className="text-lg md:text-xl text-[#5A3A28]/80 font-medium mb-12" data-id="element-38" data-mp="2ti8coo38cngz">
            Es una herramienta interactiva diseñada para ayudarte a vender.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 text-left" data-id="element-39" data-mp="33hzb30uwvmmc">
            {/* PDF */}
            <div className="bg-white p-8 rounded-3xl border border-[#5A3A28]/10 opacity-70" data-id="element-40" data-mp="2yiw8dn2elshj">
              <h3 className="text-xl font-bold mb-6 text-[#5A3A28]/60" data-id="element-41" data-mp="3i4oal2p5xzsq">
                PDF tradicional
              </h3>
              <ul className="space-y-4" data-id="element-42" data-mp="3n27p83prwel7">
                {['Información dispersa', 'Solo lectura', 'Sin herramientas', 'Difícil de consultar mientras trabajás'].map((item, i) => <li key={i} className="flex items-center gap-3 text-[#5A3A28]/70 font-medium" data-id="element-43" data-mp="2zc3uymyh5r6v" data-mpi={i}>
                    <X className="w-5 h-5 text-red-400 shrink-0" data-id="element-44" data-mp="2pez6uhl2jlnf" />
                    {item}
                  </li>)}
              </ul>
            </div>

            {/* Minicookies Lab */}
            <div className="bg-[#5A3A28] p-8 rounded-3xl shadow-xl text-[#F7F1E8] transform md:-translate-y-2" data-id="element-45" data-mp="2ge9gvuihophm">
              <h3 className="text-xl font-bold mb-6 text-[#EF9F27]" data-id="element-46" data-mp="2kge5ufxzsxxx">
                Minicookies <span className="text-[#ED93B1]" data-id="element-47" data-mp="30vdi43zvkp1y">Lab</span>
              </h3>
              <ul className="space-y-4" data-id="element-48" data-mp="30tav7su0rc1g">
                {['Todo organizado', 'Acceso inmediato desde celular', 'Calculadora incluida', 'Sistema paso a paso', 'Herramientas para vender'].map((item, i) => <li key={i} className="flex items-center gap-3 font-medium" data-id="element-49" data-mp="2hwj3qw4bpqmb" data-mpi={i}>
                    <Check className="w-5 h-5 text-[#EF9F27] shrink-0" strokeWidth={3} data-id="element-50" data-mp="2hym3i7va2y48" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <p className="text-2xl font-extrabold text-[#5A3A28]" data-id="element-51" data-mp="238y0n27g7ree">
            Más que recetas. Un sistema completo para emprender.
          </p>
        </div>
      </section>

      {/* 3. MIRÁ LA APP POR DENTRO */}
      <section id="app" className="py-8 px-0 overflow-hidden" data-id="element-52" data-mp="1u7gmvqhik1sv">
        <h2 className="sr-only" data-id="element-53" data-mp="9pnyeq318hwz">
          Mirá la app por dentro — todo lo que necesitás para emprender,
          organizado paso a paso
        </h2>
        <div className="m-0 p-0 overflow-hidden bg-black" data-id="element-54" data-mp="dskmuxf9788u">
          <img src="https://cdn.magicpatterns.com/uploads/sdPsykQ6HWFBv9BWR7coUf/ChatGPT_Image_22_jun_2026,_08_21_15_p.m..png" alt="Mirá la app por dentro: pantallas reales de recetas, primeras ventas y producción de la app Minicookies Lab" className="block w-full h-auto m-0 p-0 rounded-none border-0 shadow-none" data-id="element-55" data-mp="iqm37alaotgm" />
        </div>
      </section>

      {/* 4. LO QUE PODÉS VENDER */}
      <section id="vender" className="py-8 px-6 lg:px-12 bg-white" data-id="element-56" data-mp="3w35z0ajlwwi1">
        <div className="max-w-[1400px] mx-auto" data-id="element-57" data-mp="4quu9o9my39h">
          <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-16 text-[#5A3A28]" data-id="element-58" data-mp="4rmey41p2gkz">
            LO QUE PODÉS VENDER
          </h2>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-2" data-id="element-59" data-mp="38duymu66544f">
            {[{
            title: 'Vasos de minicookies',
            desc: 'El formato estrella para consumo al paso.',
            icon: <Coffee className="w-5 h-5" data-id="element-60" data-mp="2k4n81wno327w" />
          }, {
            title: 'Bandejas para compartir',
            desc: 'Ideales para reuniones y regalos.',
            icon: <ShoppingBag className="w-5 h-5" data-id="element-61" data-mp="2u3vyifjbpypi" />
          }, {
            title: 'Souvenirs',
            desc: 'Para cumpleaños, bodas y eventos.',
            icon: <Gift className="w-5 h-5" data-id="element-62" data-mp="21gi9d3lva7fy" />
          }, {
            title: 'Mesas dulces',
            desc: 'Propuestas premium para fiestas.',
            icon: <Star className="w-5 h-5" data-id="element-63" data-mp="2b5s0oh8vzm30" />
          }].map((item, i) => <div key={i} className="group relative rounded-2xl bg-[#F7F1E8] border border-[#5A3A28]/10 flex flex-col items-center justify-center px-[14px] py-[12px] text-center hover:bg-[#5A3A28] hover:text-white transition-colors duration-300" data-id="element-64" data-mp="1dqnygrl3ysyc" data-mpi={i}>
                <div className="text-[#C98A4B] mb-[4px] group-hover:text-[#E8B3C1] transition-colors" data-id="element-65" data-mp="3rxdrh9gkzf4x">
                  {item.icon}
                </div>
                <h3 className="text-[13px] font-bold mb-[2px]" data-id="element-66" data-mp="3mwzjtsiw677f">{item.title}</h3>
                <p className="text-[11px] leading-[1.4] opacity-80 font-medium" data-id="element-67" data-mp="3hz7pkrury902">
                  {item.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 5. IDEAL PARA VOS SI... */}
      <section id="ideal" className="py-8 px-6 lg:px-12 relative" data-id="element-68" data-mp="348cera0pthtu">
        <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
        backgroundImage: `url('https://cdn.magicpatterns.com/uploads/wnNrC9o8oofHrx9j3yxmfZ/ChatGPT_Image_18_jun_2026,_04_25_18_p.m..png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }} data-id="element-69" data-mp="348kpowda2d2e"></div>
        <div className="max-w-3xl mx-auto relative z-10 bg-white/90 backdrop-blur-md p-10 md:p-16 rounded-[2.5rem] shadow-xl border border-[#5A3A28]/10" data-id="element-70" data-mp="2fn6l62c8a9x6">
          <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-10 text-[#5A3A28]" data-id="element-71" data-mp="2kkg7h94bm5gs">
            IDEAL PARA VOS SI...
          </h2>

          <ul className="space-y-6" data-id="element-72" data-mp="2anlawvrlyf55">
            {['Querés generar ingresos desde casa', 'Te gusta la cocina y los detalles', 'Buscás un emprendimiento de baja inversión', 'Querés vender por Instagram y WhatsApp', 'Necesitás un sistema paso a paso comprobado'].map((text, i) => <li key={i} className="flex items-center gap-4 text-lg md:text-xl font-medium" data-id="element-73" data-mp="2tn7mtk0bhldp" data-mpi={i}>
                <div className="bg-[#E8B3C1] rounded-full p-1 shrink-0" data-id="element-74" data-mp="3hbqt5tzt3o35">
                  <Check className="w-5 h-5 text-[#5A3A28]" strokeWidth={3} data-id="element-75" data-mp="3m41tuz2dfdwr" />
                </div>
                {text}
              </li>)}
          </ul>
        </div>
      </section>

      {/* AUTORIDAD */}
      <section id="autoridad" className="scroll-mt-8 py-8 px-6 lg:px-12 bg-white text-center" data-id="element-76" data-mp="15oeystmyju1q">
        <div className="max-w-3xl mx-auto" data-id="element-77" data-mp="1kdt9c529ship">
          <div className="w-16 h-16 bg-[#E8B3C1]/30 rounded-full flex items-center justify-center mx-auto mb-6 text-[#5A3A28]" data-id="element-78" data-mp="1ff9o66vi39re">
            <Star className="w-8 h-8 fill-current" data-id="element-79" data-mp="rovte8lj6wt4" />
          </div>
          <h2 className="text-3xl font-extrabold mb-6 text-[#5A3A28]" data-id="element-80" data-mp="mqlx1uo2lq5x">
            Creada para emprendedoras reales
          </h2>
          <p className="text-lg md:text-xl text-[#5A3A28]/80 font-medium leading-relaxed" data-id="element-81" data-mp="11o4qhabp0rjp">
            Pensada para quienes quieren comenzar desde casa con baja inversión,
            vender por Instagram, WhatsApp, ferias o pedidos personalizados y
            transformar una receta en un negocio.
          </p>
        </div>
      </section>

      {/* PREGUNTAS FRECUENTES */}
      <FAQ data-id="element-82" data-mp="hn391di49xn5" />

      {/* URGENCY BAND */}
      <section id="lanzamiento" className="scroll-mt-8 py-8 px-6 lg:px-12 bg-[#EF9F27] text-[#5A3A28] text-center" data-id="element-83" data-mp="hoe9b3ccsn9i">
        <div className="max-w-4xl mx-auto" data-id="element-84" data-mp="qnhtkan9b8pl">
          <h2 className="text-2xl md:text-3xl font-extrabold mb-4 flex items-center justify-center gap-2" data-id="element-85" data-mp="qmgfdxay263n">
            🔥 Precio de lanzamiento
          </h2>
          <p className="text-lg font-bold" data-id="element-86" data-mp="10lp7ekm91and">
            Acceso de por vida. Actualizaciones futuras incluidas.{' '}
            <br className="hidden md:block" data-id="element-87" data-mp="15k8tcl0uemfq" />
            <span className="font-medium opacity-90" data-id="element-88" data-mp="15ixsou2p1usu">
              El valor aumentará cuando se agreguen nuevos módulos y
              herramientas.
            </span>
          </p>
        </div>
      </section>

      {/* 6. OFERTA */}
      <section id="oferta" className="py-8 px-6 lg:px-12 bg-[#5A3A28] text-[#F7F1E8]" data-id="element-89" data-mp="1jc6v2as85g1v">
        <div className="max-w-4xl mx-auto text-center" data-id="element-90" data-mp="1oaqkwm9xvbzi">
          <div className="inline-block bg-[#EF9F27] text-[#5A3A28] px-6 py-2 rounded-full font-bold tracking-widest text-sm mb-8 uppercase" data-id="element-91" data-mp="1objmz9xyddbb">
            ⭐ Oferta de lanzamiento
          </div>

          <h2 className="text-4xl md:text-5xl font-extrabold mb-8" data-id="element-92" data-mp="1tesrjua2zd3p">
            Empezá esta semana
          </h2>

          <div className="flex flex-col items-center mb-12" data-id="element-93" data-mp="1oiu7ujzp6j9m">
            <span className="text-2xl text-[#F7F1E8]/50 line-through font-medium" data-id="element-94" data-mp="1kgqt9mhqeyk4">
              $24.990
            </span>
            <span className="text-5xl md:text-6xl font-extrabold text-white mt-1" data-id="element-95" data-mp="2h4wwc4z09iwa">
              $16.990
            </span>
            <span className="text-base text-[#F7F1E8]/80 font-medium mt-3" data-id="element-96" data-mp="27fvf6bgq4vgq">
              o 3 cuotas de $5.663 sin interés con Mercado Pago
            </span>
            <img src="https://cdn.magicpatterns.com/uploads/k8sZQSvD3uyxpXfrvPiUcq/descarga_(2).png" alt="Mercado Pago" className="h-7 w-auto mt-2 bg-white rounded-md px-2 py-1" data-id="element-97" data-mp="23ds0zf2o7crr" />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-4 text-left max-w-xl mx-auto mb-12" data-id="element-98" data-mp="t876wn0v6t0n">
            {['Recetas probadas', 'Calculadora de costos', 'Packaging recomendado', 'Plan para primeras ventas', 'Acceso inmediato'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-99" data-mp="ofmftt9ceu0t" data-mpi={i}>
                <Check className="w-5 h-5 text-[#EF9F27] shrink-0" strokeWidth={3} data-id="element-100" data-mp="ah68q17kj1i5" />
                <span className="font-medium text-lg" data-id="element-101" data-mp="fi3m80hmv7db">{item}</span>
              </div>)}
          </div>

          <a href="https://minicookieslab.impultienda.ar/" target="_blank" rel="noopener" className="w-full sm:w-auto group relative inline-flex items-center justify-center gap-2 px-10 py-5 bg-[#EF9F27] hover:bg-[#d98e1f] text-[#5A3A28] rounded-full font-extrabold text-xl transition-all duration-300 shadow-xl hover:shadow-2xl hover:-translate-y-1" data-id="element-102" data-mp="lcp5xvfm7qv">
            QUIERO ACCEDER AHORA
            <ChevronRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-103" data-mp="3fg38c9j4qfoz" />
          </a>

          <p className="mt-6 text-sm text-[#F7F1E8]/70 font-medium" data-id="element-104" data-mp="3u59hoqbolmal">
            Acceso de por vida • Sin suscripciones • Disponible desde cualquier
            dispositivo
          </p>
        </div>
      </section>
    </div>;
}